import { render } from "./MenuShare.vue?vue&type=template&id=bf9608ce"
import script from "./MenuShare.vue?vue&type=script&lang=js"
export * from "./MenuShare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__